export default __webpack_public_path__ + "static/media/Map-Design-Icon.14cf6ea7.svg";